import React from "react"
import s from "./RadioInput.module.scss"
import cn from "classnames"
import Icon, { IconType } from "src/components/icon/Icon"

interface RadioInputProps {
    radioLabel: string
    radioCheckedValue: string
    setRadioCheckedValue: (value: string) => void
    final?: boolean
}


export default function RadioInput({ radioLabel, radioCheckedValue, setRadioCheckedValue, final } : RadioInputProps) {

    return (
        <li className={cn(s["radio-list__item"], { [s["radio-list__item--final"]] : final })}>
            <label className={cn(s["radio-list__item-content"], { [s["radio-list__item-content--final"]] : final })}>
                <input type="radio" name="radio" value={ radioLabel } checked={radioCheckedValue === radioLabel} onChange={e => setRadioCheckedValue(e.currentTarget.value)}/>
                <span className={s["radio-list__item-checkmark"]}>
                    <Icon className={s["radio-list__item-icon"]} type={IconType.CHECKMARK} />
                </span>
                <span className="label-200">{radioLabel}</span>
            </label>
        </li>
    )
}
